import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  button: {
    width: "100%",
    height: "48px",
    borderRadius: "10px",
    backgroundColor: "#D25A26",
    marginTop: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    border: "none",
    outline: "none",
    color: "#FFFFFF",
    transition: "opacity .15s",
    "&:hover": { opacity: 0.9 },
    "&:disabled": { cursor: "default", opacity: 0.7 },
  },
  disabled: { opacity: 0.6 },
  text: {
    fontFamily: "Inter",
    fontSize: "15px",
    fontWeight: 600,
    color: "#FFFFFF",
  },
}));

export default useStyles;
